import type { IObjectiveRequirementsAndObjectivesPurposeType } from './ObjectiveRequirementsAndObjectivesPurposeType.interface';

export default class ObjectiveRequirementsAndObjectivesPurposeType
  implements IObjectiveRequirementsAndObjectivesPurposeType {
  isOwnerOccupier: boolean;
  isInvestment: boolean;

  static build = (data: IObjectiveRequirementsAndObjectivesPurposeType) =>
    new ObjectiveRequirementsAndObjectivesPurposeType(data);

  static blank = () => new ObjectiveRequirementsAndObjectivesPurposeType();

  /**
   * Constructor
   * @param {IObjectiveRequirementsAndObjectivesPurposeType} data
   */
  constructor(data?: IObjectiveRequirementsAndObjectivesPurposeType) {
    this.isOwnerOccupier = data?.isOwnerOccupier === true;
    this.isInvestment = data?.isInvestment === true;
  }
}
